import Parse from "../../api/ApiConfig";

/**********************
	API functions
**********************/
const requestHeaders = {
	"X-Parse-Application-Id": "FortCore",
};

export const getAllAdmins = async () => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/getAdmins`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const getSingleAdmin = async (adminId) => {
	let requestBody = { id: adminId };
	try {
		const response = await fetch(`${Parse.serverURL}/functions/getAdminById`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
			body: JSON.stringify(requestBody),
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const createAdmin = async (adminDetails) => {
	let requestBody = adminDetails;
	try {
		const response = await fetch(`${Parse.serverURL}/functions/createAdmin`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
			body: JSON.stringify(requestBody),
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const verifyBvn = async (bvn) => {
	let requestBody = { bvn: bvn };
	try {
		const response = await fetch(`${Parse.serverURL}/functions/verifyBvn`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
			body: JSON.stringify(requestBody),
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const deleteAdmin = async (adminId) => {
	let requestBody = { id: adminId };
	try {
		const response = await fetch(`${Parse.serverURL}/functions/deleteUserById`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
			body: JSON.stringify(requestBody),
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const deleteMultipleAdmin = async (adminIds) => {
	let requestBody = { userIds: adminIds };
	try {
		const response = await fetch(`${Parse.serverURL}/functions/deleteUsers`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
			body: JSON.stringify(requestBody),
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const updateAdminDetails = async (userdetails) => {
	try {
		const response = await fetch(`${Parse.serverURL}/functions/editUser`, {
			method: "POST",
			headers: { "X-Parse-Application-Id": process.env.REACT_APP_APP_ID },
			body: JSON.stringify(userdetails),
		});
		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const fetchChartData = async () => {
	try {
		const url = process.env.REACT_APP_SERVER_URL + "/functions/getAdminsAnalysis";
		// Fetch data from server
		const response = await fetch(url, {
			method: "POST",
			headers: requestHeaders,
		});

		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const getDepartments = async () => {
	try {
		const url = process.env.REACT_APP_SERVER_URL + "/functions/getDepartments";
		// Fetch data from server
		const response = await fetch(url, {
			method: "POST",
			headers: requestHeaders,
		});

		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const getPrivileges = async (departmentId) => {
	let requestBody = { id: departmentId };
	try {
		const url = process.env.REACT_APP_SERVER_URL + "/functions/getRoles";
		// Fetch data from server
		const response = await fetch(url, {
			method: "POST",
			headers: requestHeaders,
			body: JSON.stringify(requestBody),
		});

		const res = await response.json();
		if (res.error) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};
